import { contentfulPropTypes, netZeroPropTypes } from '../../propTypes';

import { Button } from 'react-bootstrap';
import { LoginCard } from '../../ui';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { SpacerHr } from '../../ui/Styled';
import { averageNonEVEmissions } from '../../utils/netZeroHelper';
import errorDisc from '../../assets/svg/disc/error-disc.svg';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const CarNotFoundContainer = ({
  contentful,
  loading,
  fetched,
  carError,
  cars,
  setCars,
}) => {
  const navigate = useNavigate();

  const onAddAverageCar = () => {
    setCars([
      {
        numberPlate: '---- ---',
        annualMileage: carError.annualMileage,
        details: {
          co2Emissions: averageNonEVEmissions,
          fuelType: 'PETROL',
          make: 'AVERAGE CAR',
          registrationNumber: carError.numberPlate,
        },
      },
      ...cars,
    ]);
    navigate('/net-zero/emissions');
  };

  return (
    !loading &&
    fetched && (
      <LoginCard>
        <div className="text-center mb-3">
          <img className="py-2" src={errorDisc} alt="Error disc" />
        </div>
        <h1 className="pb-3">{contentful.title}</h1>
        <ReactMarkdown className="px-2">
          {contentful.body.replace('{NUMBER_PLATE}', carError.numberPlate)}
        </ReactMarkdown>
        <Button
          variant="link"
          className="mb-2 pt-1"
          href={contentful.link}
          target="_blank">
          {contentful.utilityText}
        </Button>
        <Button onClick={() => navigate('/net-zero/car')} className="mt-1 mb-3">
          {contentful.primaryButtonText}
        </Button>
        <SpacerHr label="or" />
        <Button onClick={onAddAverageCar} variant="secondary">
          {contentful.secondaryButtonText}
        </Button>
      </LoginCard>
    )
  );
};

CarNotFoundContainer.propTypes = {
  ...contentfulPropTypes,
  ...netZeroPropTypes,
};

export default withContentfulTag(
  CarNotFoundContainer,
  'web_app_netzero_car_not_found_page',
);
